exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-values__content {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: left;\n  flex-wrap: wrap;\n  gap: 8px;\n}", ""]);

// exports
